(function($, _) {
  var ns = window.nspace("ccc.viz.shared.views");

  /**
   * The source/definition/notes that appears below the map
   */
  ns.SourceDefinitionNotesView = Backbone.View.extend({
    el: "#source-definition-notes-container",
    name: "Source/Definition/Notes view",
    templateSelector: "#source-definition-notes-template",

    initialize: function(options) {
      _.bindAll(this, "render", "loadTemplate", "getInitialRenderPromise");

      this.initialRenderPromise = $.Deferred();

      this.selectorsModel = options.selectorsModel;

      this.model.on("change", this.render);
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    render: function() {
      var self = this;

      // Verify this selector's container is present
      if (this.$el.length === 0) {
        throw "Could not find the " + this.name + " container: " + this.el;
      }

      // Load the template
      this.loadTemplate();

      // Only rerender if the indicator has change from the last render
      if (this.selectorsModel.get("indicatorId") === this.currentIndicatorId) {
        return;
      }

      this.currentIndicatorId = this.selectorsModel.get("indicatorId");

      // Render the text
      var response = self.model.get("response");
      var templateData = {
        source: response.source,
        definition: response.definition,
        notes: response.notes
      };

      // Render the output
      self.$el.html(self.template(templateData));

      // Animate the transition
      self.$el.hide().fadeIn(function() {
        self.initialRenderPromise.resolve();
      });
    }
  });
})(jQuery, _);
